import { createContext, useReducer } from 'react';

export const Store = createContext();

function safeParse(jsonStr) {
  try {
    const parsed = JSON.parse(jsonStr);
    return parsed;
  } catch (err) {
    console.warn('Invalid JSON in localStorage:', jsonStr);
    return null;
  }
}

const rawUserInfo = localStorage.getItem('userInfo');
const rawResentLink = localStorage.getItem('resentLink');
const rawResentBread = localStorage.getItem('resentBread');

const initialState = {
  userInfo: rawUserInfo ? safeParse(rawUserInfo) : null,
  resentLink: rawResentLink ? safeParse(rawResentLink) : null,
  resentBread: rawResentBread ? safeParse(rawResentBread) : null,
};

function reducer(state, action) {
  switch (action.type) {
    case 'USER_SIGNIN':
      localStorage.setItem('userInfo', JSON.stringify(action.payload));
      return { ...state, userInfo: action.payload };
    case 'USER_SIGNOUT':
      localStorage.removeItem('userInfo');
      return { ...state, userInfo: null };

    case 'PREV-LINK':
      localStorage.setItem('resentLink', JSON.stringify(action.payload));
      return { ...state, resentLink: action.payload };

    case 'SET_BREADCRUMB':
      localStorage.setItem('resentBread', JSON.stringify(action.payload));
      return { ...state, resentBread: action.payload };
    default:
      return state;
  }
}

export function StoreProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };
  return <Store.Provider value={value}>{props.children}</Store.Provider>;
}
